import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-check-circle',
  imports: [],
  templateUrl: './check-circle.html',
  styleUrl: './check-circle.scss',
})
export class CheckCircle {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
